import { render, staticRenderFns } from "./RemovePath.vue?vue&type=template&id=2ec308b0&scoped=true&"
import script from "./RemovePath.vue?vue&type=script&lang=js&"
export * from "./RemovePath.vue?vue&type=script&lang=js&"
import style0 from "./RemovePath.vue?vue&type=style&index=0&id=2ec308b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec308b0",
  null
  
)

export default component.exports